$(document).ready(function() {

  $(document).on('click', 'a[href*="#shopify-section-"]', function(e) {
  var href = $(this).attr('href');
  var url = new URL(href, window.location.origin);
  var hash = url.hash;

  if (!hash) return;

  // Close Dawn mobile menu drawer
  var $drawer = $('#Details-menu-drawer-container');

  if ($drawer.length) {
    $drawer.removeClass('menu-opening');
    $drawer.removeAttr('open');
    $drawer.find('summary').attr('aria-expanded', 'false');

    // Remove body scroll lock used by Dawn
    $('body').removeClass('overflow-hidden-mobile');
    $('body').removeClass('overflow-hidden-tablet');
  }

  // Already on homepage
  if ($('body').hasClass('template-index')) {
    e.preventDefault();

    var $target = $(hash);

    if ($target.length) {
      var headerHeight = $('.header-wrapper').outerHeight() || 0;

      // Small delay so drawer closes before scroll starts
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: $target.offset().top - headerHeight
        }, 1000);
      }, 300);
    }
  } else {
    sessionStorage.setItem('homepageScrollTarget', hash);
    e.preventDefault();
    window.location.href = url.origin + url.pathname + url.search;
  }
});

$(window).on('load', function() {
  if (!$('body').hasClass('template-index')) return;

  var hash = sessionStorage.getItem('homepageScrollTarget');
  if (!hash) return;

  sessionStorage.removeItem('homepageScrollTarget');

  var attempts = 0;

  var interval = setInterval(function() {
    var $target = $(hash);

    if ($target.length) {
      clearInterval(interval);

      var headerHeight = $('.header-wrapper').outerHeight() || 0;

      $('html, body').animate({
        scrollTop: $target.offset().top - headerHeight
      }, 1000);
    }

    attempts++;

    if (attempts > 25) {
      clearInterval(interval);
    }
  }, 200);
});

  function close_accordion_section() {
    $('.accordion .accordion-section-title').removeClass('active');
    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  if (window.location.href === 'https://lider.com.au/policies/terms-of-service') {
    $('.shopify-policy__title h1').text('Terms and Conditions – Lider Cigars');
  }

  const urlParams = new URLSearchParams(window.location.search);
  const fromPopup = urlParams.get("popupsubmitted");
  const localFlag = localStorage.getItem("popupSubmitted");

  if (fromPopup === "true" || localFlag === "true") {
    localStorage.removeItem("popupSubmitted");

    if (fromPopup === "true") {
      const url = window.location.pathname;
      window.history.replaceState({}, document.title, url);
    } else {
      window.location.href = "/";
    }

  }

  const popupSelector = ".discount-popup-sec";
  const popup = document.querySelector(popupSelector);
  const openBtn = document.querySelector(".sticky-popup-btn-fixed p");

  if (openBtn && popup) {
    openBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      openPopup();
    });
  }

  document.addEventListener("click", function(e) {
    if (e.target.closest(".discount-popup-close")) {
      closePopup();
      return;
    }
    if (popup && !e.target.closest(popupSelector)) {
      closePopup();
    }
  });

  function openPopup() {
    document.body.classList.add("discount-popup-visible");
    popup.classList.add("discount-popup-active");
    popup.show();
  }

  function closePopup() {
    document.body.classList.remove("discount-popup-visible");
    popup.classList.remove("discount-popup-active");
    popup.hide();
  }

  $(".single-announce .announcement-bar__message a").click(function(e) {
    e.stopPropagation();
    $("body").addClass("discount-popup-visible");
    $(".discount-popup-sec").addClass('discount-popup-active').show();
  });

  $('.our-collaborators-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    autoplay: false, // optional
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow: '<div class="prev-collab"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8363 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="white"/></svg></div>',
    nextArrow: '<div class="next-collab"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.282573 1.68781C0.192325 1.59231 0.121771 1.47996 0.0749407 1.35719C0.0281096 1.23442 0.00591755 1.10363 0.00963306 0.972287C0.0133486 0.840941 0.0428982 0.711614 0.0965948 0.591688C0.150291 0.471763 0.227083 0.363588 0.322586 0.27334C0.418088 0.183092 0.530432 0.112538 0.653202 0.065707C0.775971 0.018876 0.906761 -0.00331544 1.03811 0.000400135C1.16945 0.00411571 1.29878 0.0336653 1.41871 0.0873618C1.53863 0.141058 1.64681 0.21785 1.73705 0.313353L10.2399 9.31634C10.4155 9.50207 10.5133 9.74797 10.5133 10.0036C10.5133 10.2592 10.4155 10.5051 10.2399 10.6908L1.73705 19.6948C1.6474 19.7924 1.53925 19.8712 1.41889 19.9266C1.29852 19.9821 1.16833 20.013 1.0359 20.0177C0.903459 20.0224 0.771405 20.0008 0.647408 19.954C0.523409 19.9073 0.409938 19.8363 0.313585 19.7454C0.217234 19.6544 0.139919 19.5451 0.0861349 19.424C0.0323515 19.3029 0.00316906 19.1723 0.000284195 19.0398C-0.00260162 18.9073 0.0208673 18.7756 0.0693274 18.6522C0.117787 18.5289 0.190272 18.4164 0.282573 18.3213L8.13718 10.0036L0.282573 1.68781Z" fill="white"/></svg></div>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        }
    ]
});

  $('.collaborator-img-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    nextArrow: '<div class="collaborator-slide next-video"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.282573 1.68781C0.192325 1.59231 0.121771 1.47996 0.0749407 1.35719C0.0281096 1.23442 0.00591755 1.10363 0.00963306 0.972287C0.0133486 0.840941 0.0428982 0.711614 0.0965948 0.591688C0.150291 0.471763 0.227083 0.363588 0.322586 0.27334C0.418088 0.183092 0.530432 0.112538 0.653202 0.065707C0.775971 0.018876 0.906761 -0.00331544 1.03811 0.000400135C1.16945 0.00411571 1.29878 0.0336653 1.41871 0.0873618C1.53863 0.141058 1.64681 0.21785 1.73705 0.313353L10.2399 9.31634C10.4155 9.50207 10.5133 9.74797 10.5133 10.0036C10.5133 10.2592 10.4155 10.5051 10.2399 10.6908L1.73705 19.6948C1.6474 19.7924 1.53925 19.8712 1.41889 19.9266C1.29852 19.9821 1.16833 20.013 1.0359 20.0177C0.903459 20.0224 0.771405 20.0008 0.647408 19.954C0.523409 19.9073 0.409938 19.8363 0.313585 19.7454C0.217234 19.6544 0.139919 19.5451 0.0861349 19.424C0.0323515 19.3029 0.00316906 19.1723 0.000284195 19.0398C-0.00260162 18.9073 0.0208673 18.7756 0.0693274 18.6522C0.117787 18.5289 0.190272 18.4164 0.282573 18.3213L8.13718 10.0036L0.282573 1.68781Z" fill="white"/></svg></div>',
    prevArrow: '<div class="collaborator-slide prev-video"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8363 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="white"/></svg></div>'
  });

  $('.collaborator-products-list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    autoplay: false,
    infinite: false,
    arrows: true,
    dots: false,
    prevArrow: '<div class="prev-prd"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.37659 19C9.53474 19 9.69658 18.9362 9.81795 18.8124C10.0607 18.5648 10.0607 18.1596 9.81795 17.912L1.50975 9.43716L9.69658 1.08609C9.93932 0.838484 9.93932 0.433311 9.69658 0.185705C9.45384 -0.0619011 9.05664 -0.0619011 8.8139 0.185705L0.182052 8.98697C-0.0606841 9.23457 -0.0606841 9.63975 0.182052 9.88735L8.93159 18.8124C9.05664 18.94 9.21477 19 9.37659 19Z" fill="black"/></svg></div>',
    nextArrow: '<div class="next-prd"><svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.623409 19C0.465262 19 0.30342 18.9362 0.182052 18.8124C-0.0606842 18.5648 -0.0606842 18.1596 0.182052 17.912L8.49025 9.43716L0.30342 1.08609C0.0606833 0.838484 0.0606833 0.433311 0.30342 0.185705C0.546156 -0.0619011 0.943361 -0.0619011 1.1861 0.185705L9.81795 8.98697C10.0607 9.23457 10.0607 9.63975 9.81795 9.88735L1.06841 18.8124C0.943362 18.94 0.785233 19 0.623409 19Z" fill="black"/></svg></div>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3
        }
      }
    ]
  });

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.checkout-collaborator-pdp');
    if (!button) return;
    e.preventDefault();
    const variantId = button.dataset.variantId;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const item = await response.json();
      console.log('Added to cart:', item);
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  });

  $('#clear-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/clear.js',
      type: 'POST',
      success: function(data) {
        window.location.href = '/cart';
      },
      error: function(error) {
        console.error('Error clearing the cart:', error);
      }
    });
  });

  $('.accordion-section-title').click(function(e) {
    var currentAttrValue = $(this).attr('href');
    if($(e.target).is('.active')) {
      close_accordion_section();
    }else {
      close_accordion_section();
      $(this).addClass('active');
      $('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
    }
    e.preventDefault();
  });
});

const header = document.querySelector('.header-wrapper');

const startPoint = 50;
let lastScrollTop = 0;

function handleScroll() {
  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  if (currentScroll <= startPoint) {
    header.classList.remove('sticky-active');
  } else if (currentScroll > lastScrollTop) {
    header.classList.add('sticky-active');
  } else {
    header.classList.remove('sticky-active');
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}

window.addEventListener('scroll', handleScroll);